module.exports = __webpack_public_path__ + "static/media/logomr.acbbf0af.png";